/* eslint-disable react/jsx-props-no-spreading */
const WarningIcon20 = ({ width = 20, height = 20, ...props }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M3.4168 17.5H16.5839C17.9303 17.5 18.7696 16.0271 18.0964 14.8541L11.5129 3.37976C10.8397 2.20675 9.16099 2.20675 8.48778 3.37976L1.90425 14.8541C1.23104 16.0271 2.07037 17.5 3.4168 17.5ZM10.0003 11.3263C9.51946 11.3263 9.12602 10.9294 9.12602 10.4443V8.68036C9.12602 8.19528 9.51946 7.7984 10.0003 7.7984C10.4812 7.7984 10.8746 8.19528 10.8746 8.68036V10.4443C10.8746 10.9294 10.4812 11.3263 10.0003 11.3263ZM10.8746 14.8541H9.12602V13.0902H10.8746V14.8541Z"
			fill="#CB2F4B"
		/>
	</svg>
);

export default WarningIcon20;
